import React, { useState } from "react";

import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";

import { messages } from "./Recordings.messages";
import styles from "./Recordings.module.scss";
import { Slide1, Slide2, Slide3, Slide4 } from "./slides/Slides";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";

interface Recordings {
  title: string;
}

export const Recordings: React.FC<Recordings> = () => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);

  const renderSlide = (): JSX.Element => {
    switch (selectedOption) {
      case 0:
        return <Slide1 />;
      case 1:
        return <Slide2 />;
      case 2:
        return <Slide3 />;
      case 3:
        return <Slide4 />;

      default:
        return <Slide1 />;
    }
  };

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          <div className={styles.slide}>{renderSlide()}</div>
          <div className={styles.switch}>
            <SwitchOption
              onClick={setSelectedOption}
              activeItem={selectedOption}
              items={[
                {
                  name: formatMessage(messages.G2_P3_Tab1_Title),
                },
                {
                  name: formatMessage(messages.G2_P3_Tab2_Title),
                },
                {
                  name: formatMessage(messages.G2_P3_Tab3_Title),
                },
                {
                  name: formatMessage(messages.G2_P3_Tab4_Title),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
